import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ChatFindocModal, ChatOrderModal} from 'src/components'

const App = () => {
  useEffect(() => {
    const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
    document.title = env === "production" ? "Andalan - Pupuk Indonesia" : `Andalan - Server Latihan`;
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
            <ChatOrderModal />
            <ChatFindocModal />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
